const contentTypes = {
  ARTICLE: "ARTICLE",
  BUNDLE: "BUNDLE",
  GENERATION_GENIUS_VIDEO: "GENERATION_GENIUS_VIDEO",
  INTERACTIVE_VIDEO: "INTERACTIVE_VIDEO",
  PHET_SIMULATION: "PHET_SIMULATION",
} as const;

export type ContentType = (typeof contentTypes)[keyof typeof contentTypes];

export const UNLEVELLED_CONTENT_TYPES: ContentType[] = [
  contentTypes.GENERATION_GENIUS_VIDEO,
  contentTypes.PHET_SIMULATION,
];

export default contentTypes;
